import { Pipe, PipeTransform } from '@angular/core';
import { ApiResponse, Match, WOption } from '../interfaces';

import { deepClone, trimPluses } from '../utils';
import { MechanicsService } from '../_services/mechanics.service';

let cache: any = null;

@Pipe({
    name: 'transformSemanticOrStringSearch',
    standalone: false
})
export class transformSemanticOrStringSearchPipe implements PipeTransform {

	constructor(private ms: MechanicsService) {

	}

	transform(apiResponse: ApiResponse, ...args: any[]): Partial<ApiResponse> {

		const l = `transformSemanticOrStringSearch - `

		if (this.ms.isPipesLocked) {
			// console.log(`${l}Pipes are locked, skipping - Returning cache = `, cache)
			return cache
		}

		// console.log(`${l}raw apiResponse = `, deepClone(apiResponse), `args = `, args)

		const typedTerm: string = decodeURIComponent(apiResponse.original_term || "");

		if (!apiResponse.matches || !apiResponse.matches?.length) {
			// console.info(`${l}No match, returning []`)
			return {
				matches: []
			}
		}
		// console.time(`Highlighting took`)

		const state: any = args[0]; // This is the form in the left column :

		/*
			state = {
				"term": "sushi",
				"searchType": "semanticSearch",
				"inputLang": "en",
				"outputLang": "en",
				"offices": [
					{
						"value": "FR",
						"label": "(FR) INPI"
					},
					{
						"value": "DE",
						"label": "(DE) DPMA"
					}
				],
				"display": "all",
				"niceClass": [
					{
						"value": "1",
						"label": "1",
						"label2": "1 - Chemicals used in industry, science and photography, as well as in agriculture, horticulture and forestry; unprocessed artificial resins, unprocessed plastics; manures; fire extinguishing compositions; tempering and soldering preparations; chemical substances for preserving foodstuffs; tanning substances; adhesives used in industry."
					},
					{
						"value": "44",
						"label": "44",
						"label2": "44 - Medical services; veterinary services; hygienic and beauty care for human beings or animals; agriculture, horticulture and forestry services."
					}
				],
				"sort": "office",
				"showNullResults": false,
				"columnSortBy": "nbTotalOccurences",
				"columnSortOrder": 1,
				"yearDataDisplay": "projected",
				"debounceTime": 400
			}
		*/

		const niceClasses = Array.isArray(state.niceClass) ? state.niceClass.map((nc: WOption) => "" + nc.value) : [];

		// console.log(`${l}niceClasses = `, niceClasses);

		apiResponse.matches = apiResponse.matches.map((match: Match, index: number): any => {

			let l = `apiResponse transforms - `

			// console.log(`47 ${l}match = `, deepClone(match))

			match.nbOccurences = ((match.nbOccurences || []) as number[]).map((occ: any, index: number) => {
				let toReturn = {
					office: apiResponse.offices[index],
					value: (typeof (occ.value) === "undefined") ? occ : occ.value
				}
				return toReturn
			});

			// console.log(`57 ${l}match.term = `, match.term);
			match.term = match.term || ""; // can be null...

			match.term_for_link = match.term.trim().replace(/_/g, " ");

			if (state.searchType === 'stringSearch') {

				/* ~~~~~~ START HIGHLIGHTING ~~~~~~
				
				sushi --> <em>Sushi</em>
				
				electric car --> <em>Electric</em> <em>car</em>
				
				electric_car --> <em>Electric</em> <em>car</em>
				*/

				l = `highlighting - `

				const term1 = trimPluses(typedTerm.trim());
				const term2 = trimPluses(args[0].term.trim())

				// console.log(`85 ${l}term1==='${term1}', term2==='${term2}'`)

				if (term1 === term2) {
					try {
						const typedSplit: string[] = term1.replace(/[_\+]/g, " ").split(" ").filter(m => m.length);

						// console.log(`91 ${l}typedSplit = `, typedSplit)

						for (let word of typedSplit) {

							// console.log(`95 ${l}word = ${word}`)
							if (match.highlighted?.includes("<em>")) continue; // already highlighted

							match.highlighted = (match.highlighted || match.term).replace(new RegExp(word, "ig"), (matched) => {
								// console.log(`98 ${l}matched = `, matched)
								return `<em>${matched}</em>`
							});
						}

					} catch (err) {
						// Regex probably failed because there's a special character like "+"
					}
					// ~~~~~~ END HIGHLIGHTING ~~~~~~
				}
			} else {
				match.highlighted = match.term
			}

			// console.log(`111 ${l}Map : returning match = `, structuredClone(match));

			return match
		})
		
			.filter((match: Match) =>{
				
				if(match.nbTotalOccurences == 0) return false;
				
				if(!match.term) return false;
				
				if((match.similarityScore as unknown) == "NaN") return false;
	
				if(match.NiceClass && niceClasses.length && !niceClasses.includes(""+match.NiceClass)) return false;

				return true;
			});
			

		// console.timeEnd(`Highlighting took`)

		// apiResponse.matches.reverse(); // API results arrive sorted by inverse score (?)

		// console.log(`${l}state : `, state)
		const { columnSortBy, columnSortOrder, ...rest } = state;
		// console.log(`${l}columnSortBy='${columnSortBy}', columnSortOrder='${columnSortOrder}'`)
		// columnSortBy = term, similarityScore, NiceClass, nbTotalOccurences
		// columnSortOrder = 1, -1

		apiResponse.matches.sort((a: any, b: any) => {

			// console.log(`${l}a[${columnSortBy}]='${a[columnSortBy]}', b[${columnSortBy}]='${b[columnSortBy]}'`)

			if (a[columnSortBy] !== b[columnSortBy]) {
				if (b[columnSortBy].localeCompare) {
					return -1 * columnSortOrder * (b[columnSortBy].localeCompare(a[columnSortBy]))
				}
				return columnSortOrder * (b[columnSortBy] - a[columnSortBy])
			}
			return b.nbTotalOccurences - a.nbTotalOccurences
		})

		cache = apiResponse;

		// console.log(`${l}locking pipes`)
		this.ms.isPipesLocked = true; // Forbidding the transforms pipes to run every time a keyboard key is hit

		// console.log(`${l}returning apiResponse = `, apiResponse)
		return apiResponse
	}

}
